import React from "react";
import {
  Box,
  Grid,
  Link,
  Typography,
  FormControlLabel,
  RadioGroup,
  Radio,
} from "@mui/material";
import { Controller } from "react-hook-form";
import { Control } from "react-hook-form/dist/types/form";
import { LaptopRenewalFormValue } from "../../LaptopReplacementModal";
import { AssetWithState } from "../../../AssetList/AssetList";

const formTitleStyles = {
  marginBottom: "12px",
  fontFamily: "Inter",
  fontWeight: "600",
  fontSize: "16px",
};

const formSubTitleStyles = {
  marginBottom: "12px",
  fontFamily: "Inter",
  fontWeight: "400",
  fontSize: "16px",
};

type Props = {
  isShow: boolean;
  control: Control<LaptopRenewalFormValue, any>;
  currentAsset: AssetWithState;
};

const BuyBackForm = ({ isShow, control, currentAsset }: Props) =>
  isShow ? (
    <>
      <Grid item xs={12}>
        <Box sx={{ marginBottom: "32px" }}>
          {currentAsset.modelName && (
            <Typography variant="h6" component="h2" sx={formTitleStyles}>
              End Of Life Model:{" "}
              <span style={{ fontWeight: 400 }}>{currentAsset.modelName}</span>
            </Typography>
          )}
          <Link
            target="_blank"
            href={currentAsset.buyBackLink}
            color="#BD4257;"
            underline="hover"
          >
            Check the price
          </Link>
        </Box>
        <Box sx={{ marginBottom: "40px" }}>
          <Typography variant="h6" component="h2" sx={formTitleStyles}>
            Select Buyback Preference
          </Typography>
          <Typography component="div" sx={formSubTitleStyles}>
            Would you like to buy old laptop? Refer to the{" "}
            <Link
              target="_blank"
              href="https://thoughtworks.atlassian.net/wiki/spaces/POLICY/pages/271384608/Laptop+policy+-+Global"
              color="#BD4257"
              underline="hover"
            >
              Global Laptop Policy
            </Link>
            .
          </Typography>
          <Controller
            rules={{
              required: true,
            }}
            name="isBuyOldLaptop"
            control={control}
            render={({ field }) => (
              <RadioGroup
                aria-label="isBuyOldLaptop"
                name="isBuyOldLaptop"
                {...field}
                row
              >
                <FormControlLabel
                  value="yes"
                  control={
                    <Radio
                      size="small"
                      id={"yes"}
                      sx={{
                        "&.Mui-checked": {
                          color: "#4F52BD",
                        },
                      }}
                    />
                  }
                  label="Yes"
                />
                <FormControlLabel
                  value="no"
                  control={
                    <Radio
                      size="small"
                      id={"no"}
                      sx={{
                        "&.Mui-checked": {
                          color: "#4F52BD",
                        },
                      }}
                    />
                  }
                  label="No"
                />
              </RadioGroup>
            )}
          />
        </Box>
      </Grid>
    </>
  ) : null;

export default BuyBackForm;
